// Current endpoints return either prose, {error: prose}, {message: prose},
// or {error: {message, type, retryable}}. Prefer the human message over a code.
export function apiErrorMessage(body, fallback) {
  if (typeof body === 'string') {
    try {
      return apiErrorMessage(JSON.parse(body), fallback);
    } catch (_) {
      return body || fallback;
    }
  }
  for (const message of [body?.message, body?.error?.message, body?.error]) {
    if (typeof message === 'string' && message) return message;
  }
  return fallback;
}

export async function readApiError(response, fallback = `Request failed: ${response.status}`) {
  return apiErrorMessage(await response.text().catch(() => ''), fallback);
}
